document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.js-article-content');
  if (!container) return;

  const shortcodeRegex = /\[article=['"]([^'"]+)['"]\]\[\/article\]/g;
  const html = container.innerHTML;
  const matches = [...html.matchAll(shortcodeRegex)];
  if (!matches.length) return;

  let processedHtml = html;

  matches.forEach(match => {
    const handle = match[1];

    const placeholder = `<!--article:${handle}-->`;
    processedHtml = processedHtml.replace(match[0], placeholder);

    fetch(`/blogs/${Shopify.routes.root.split('/')[2] || 'news'}/${handle}?view=json`)
      .then(res => res.json())
      .then(data => {
        const a = data.article;

        const gridItem = `
          <div class="article-grid-item">
            <div class="article-grid-item__image">
              ${a.image ? `
                <a href="${a.url}">
                  <img src="${a.image}" alt="${a.title}" loading="lazy">
                </a>` : ''}
            </div>
            <div class="article-grid-item__content">
              <h3 class="article-grid-item__title">
                <a href="${a.url}">${a.title}</a>
              </h3>
              <div class="article-grid-item__button">
                <a href="${a.url}" class="button shopify-block">
                  Dowiedz się więcej
                </a>
              </div>
            </div>
          </div>
        `;

        container.innerHTML = container.innerHTML.replace(placeholder, gridItem);
      })
      .catch(err => {
        console.error('Nie udało się pobrać artykułu:', handle, err);
      });
  });

  container.innerHTML = processedHtml;
});